import { useSelector } from 'react-redux';
import { Navigate, useLocation } from 'react-router';

const RedirectIfAuth = ({ children }) => {
  const isAuthenticated = useSelector((state) => state.user.sessionId !== null);
  const location = useLocation();

  if (isAuthenticated) {
    const redirect = new URLSearchParams(location.search).get('redirect') || '/';
    return <Navigate to={redirect} replace />;
  }

  return children;
};

export default RedirectIfAuth;
